import React, { useContext } from "react";
// React Bootstrap
import { Accordion, Card, Button, Alert } from "react-bootstrap";
// Componentes
import FormEspiritualidad from "../formularios/FormEspiritualidad";
import VistaEspiritualidad from "../vistas/VistaEspiritualidad";
// Contexto
import { ModalContext } from "../../../../context/modalContext";

const Espiritualidad = ({ datosMisionObra, handlePutMisionObra }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  return (
    <Accordion defaultActiveKey="1">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Estructura de la obra
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle("Editar estructura de la obra");
              modalSetContent(<FormEspiritualidad defaultValues={datosMisionObra} submissionHandler={handlePutMisionObra} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaEspiritualidad datosMisionObra={datosMisionObra} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default Espiritualidad;
